module.exports = __webpack_public_path__ + "img/signin-logo.8709ca56.svg";